import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Cookies from "js-cookie";
import { Search } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const AdminUsersList = () => {
  const [users, setUsers] = useState([]);
  const [total, setTotal] = useState(0);
  const [q, setQ] = useState("");
  const [accountType, setAccountType] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      setError("");
      try {
        const token = Cookies.get("token");
        const params = { page: 1, limit: 50 };
        if (q.trim()) params.q = q.trim();
        if (accountType) params.account_type = accountType;
        const res = await axios.get(`${BACKEND_URL}/api/admin/users`, {
          headers: { Authorization: `Bearer ${token}` },
          params,
        });
        setUsers(res.data.users || []);
        setTotal(res.data.total || 0);
      } catch (err) {
        setError(err.response?.data?.detail || "Failed to load users");
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [q, accountType]);

  return (
    <div data-testid="admin-users-list">
      <h1 className="font-heading text-2xl font-bold mb-2">Users</h1>
      <p className="text-[#9CA3AF] text-sm mb-6">{total} total</p>

      <div className="flex flex-col sm:flex-row gap-3 mb-6">
        <div className="relative flex-1">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#9CA3AF]" />
          <input
            type="search"
            placeholder="Search by email"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            className="w-full pl-10 pr-4 py-2.5 rounded-lg bg-white/5 border border-white/10 text-sm text-[#F3F4F6] placeholder:text-[#6B7280] focus:outline-none focus:border-[#00D1FF]/50"
          />
        </div>
        <select
          value={accountType}
          onChange={(e) => setAccountType(e.target.value)}
          className="px-4 py-2.5 rounded-lg bg-white/5 border border-white/10 text-sm text-[#F3F4F6] focus:outline-none"
        >
          <option value="">All types</option>
          <option value="client">Client</option>
          <option value="partner">Partner</option>
          <option value="admin">Admin</option>
        </select>
      </div>

      {error && <p className="text-red-400 mb-4">{error}</p>}
      {loading ? (
        <p className="text-[#9CA3AF]">Loading…</p>
      ) : (
        <div className="overflow-x-auto rounded-xl border border-white/10">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-white/10 text-left text-[#9CA3AF]">
                <th className="px-4 py-3 font-medium">Email</th>
                <th className="px-4 py-3 font-medium">Type</th>
                <th className="px-4 py-3 font-medium">Tier</th>
                <th className="px-4 py-3 font-medium">Billing</th>
                <th className="px-4 py-3 font-medium">Created</th>
              </tr>
            </thead>
            <tbody>
              {users.map((user) => (
                <tr key={user.id} className="border-b border-white/5 hover:bg-white/[0.02]">
                  <td className="px-4 py-3">
                    <Link
                      to={`/admin/users/${user.id}`}
                      className="text-[#00D1FF] hover:underline"
                    >
                      {user.email}
                    </Link>
                  </td>
                  <td className="px-4 py-3 capitalize">{user.account_type}</td>
                  <td className="px-4 py-3">{user.ai_tier ?? "—"}</td>
                  <td className="px-4 py-3 capitalize">{user.billing_plan || "stripe"}</td>
                  <td className="px-4 py-3 text-[#9CA3AF]">
                    {user.created_at ? new Date(user.created_at).toLocaleDateString() : "—"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AdminUsersList;
